// Keeps the cashback drawer's "Você ganhará X" line in sync with the cart.
//
// The widget is rendered server-side inside the header and never refreshed
// directly by the AJAX cart flow (common.js#getAndUpdateMinicartInFront only
// swaps .cart-drawer.innerHTML). We piggyback on that re-render: every time
// the cart drawer mutates, we recompute the earn amount from the freshly
// rendered cart drawer's cashback row and update the widget. When the cart
// is empty, we hide the line entirely — the "Cadastre-se" CTA below stands
// in for the prior empty-state copy.

(function () {
  'use strict';

  if (window.__vinselCashbackWidget) return;
  window.__vinselCashbackWidget = true;

  function brl(cents) {
    return 'R$ ' + (cents / 100)
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Reads the current cart subtotal (raw, not pix-multiplied) from the cart
  // drawer DOM. Returns 0 for empty carts and null when the drawer hasn't
  // rendered enough info yet (e.g. cashback disabled, or pre-mount race).
  function readCartSubtotalCents() {
    var drawer = document.querySelector('.cart-drawer');
    if (!drawer) return null;
    if (drawer.querySelector('.cart-drawer-empty')) return 0;
    var row = drawer.querySelector('[data-cashback-row]');
    if (!row) return null;
    var v = parseInt(row.getAttribute('data-cashback-subtotal-cents'), 10);
    return isNaN(v) ? null : v;
  }

  function update() {
    var earnEl = document.querySelector('[data-cashback-widget-earn]');
    if (!earnEl) return;

    var subtotal = readCartSubtotalCents();
    if (subtotal === null) return;

    if (subtotal <= 0) {
      earnEl.hidden = true;
      return;
    }

    var pct = parseFloat(earnEl.getAttribute('data-cashback-pct'));
    var pixMul = parseFloat(earnEl.getAttribute('data-cashback-pix-multiplier'));
    var minCents = parseInt(earnEl.getAttribute('data-cashback-min-cents'), 10) || 0;
    var maxCents = parseInt(earnEl.getAttribute('data-cashback-max-cents'), 10) || 0;
    if (isNaN(pct) || isNaN(pixMul)) return;

    var baseCents = Math.round(subtotal * pixMul);
    var earn;
    if (minCents > 0 && baseCents < minCents) {
      earn = 0;
    } else {
      earn = Math.round(baseCents * pct / 100);
      if (maxCents > 0 && earn > maxCents) earn = maxCents;
    }

    earnEl.hidden = false;
    var valueEl = earnEl.querySelector('[data-cashback-widget-earn-value]');
    if (valueEl) valueEl.textContent = brl(earn);
  }

  function boot() {
    var drawer = document.querySelector('.cart-drawer');
    if (drawer) {
      var debounceTimer = null;
      new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(update, 50);
      }).observe(drawer, { childList: true, subtree: true });
    }
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
